import React from "react"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import ArrowLeftIcon from "../../content/assets/svg/arrow-left.svg"

const BackLink = ({ linkText, linkHref }) => {
  return linkHref.includes("#") ? (
    <AnchorLink className="back-link" to={linkHref}>
      <ArrowLeftIcon /> {linkText}
    </AnchorLink>
  ) : (
    <Link className="back-link" to={linkHref}>
      <ArrowLeftIcon /> {linkText}
    </Link>
  )
}

export default BackLink
